import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authRegister, authLogout } from "@/lib/apiClient";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  useEffect(() => {
    authMe().then(setUser).catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("d20-logout", onLogout);
    return () => window.removeEventListener("d20-logout", onLogout);
  }, []);

  const login = useCallback(async (email, password) => { const u = await authLogin(email, password); setUser(u); return u; }, []);
  const register = useCallback(async (body) => { const u = await authRegister(body); setUser(u); return u; }, []);
  const logout = useCallback(async () => { try { await authLogout(); } finally { setUser(false); } }, []);
  const refresh = useCallback(() => authMe().then(setUser).catch(() => setUser(false)), []);

  return <AuthContext.Provider value={{ user, login, register, logout, refresh, setUser }}>{children}</AuthContext.Provider>;
};
